module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.92db9a07.otf";